import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { SimpleFlexbox } from 'ctm-components';
import { standardFeatures } from '../../core/state_selectors';
import styles from './accessories.css';

/**
 * Renders the standard features component
 * @param {Object} props - The component props
 * @param {Array} props.features - list of features to render
 * @returns {Node} - Returns standard features content component
 */
const _StandardFeatures = ({ features }) => (
    <>
        <SimpleFlexbox margin="bottom_xsmall">
            <strong>These are fitted standard to your vehicle and do not need to be declared.</strong>
        </SimpleFlexbox>
        <SimpleFlexbox wrap display="flex">
            { features.map((feature) => <p key={feature.code} className={styles.standardFeatures}>{feature.label}</p>) }
        </SimpleFlexbox>
    </>
);

_StandardFeatures.propTypes = {
    features: PropTypes.array.isRequired
};

/**
 * Maps the store state to props
 * @param {Immutable.Map} state - The application state
 * @returns {Object} - Required props
 */
const mapStateToProps = (state) => {
    return {
        features: standardFeatures(state).toJS()
    };
};

const StandardFeatures = connect(mapStateToProps)(_StandardFeatures);
export { _StandardFeatures, StandardFeatures };
